




















import { Component, Vue } from "vue-property-decorator"

@Component({
})
export default class AdminImpersonateLanding extends Vue {
  isLinkInvalid = false
  isLoading = false

  mounted() {
    if (! this.$route.query.access_token) {
      this.isLinkInvalid = true
      return
    }

    this.isLoading = true
    this.$store.dispatch("Auth/impersonateUser", this.$route.query.access_token)
  }
}
